import { createSlice } from '@reduxjs/toolkit';


export const mapSlice = createSlice({
    name: 'map',

    initialState: {
        mapService: 'google',
        googleAvailable: false,
        center: { lat: 23.5251, lng: 77.8081 },
        zoom: 6,
        googleMapTypeId: 'roadmap', //'satellite','hybrid','terrain'
        needBounding: null,
        mapControl: 'asset', //'asset','event','zone','marker','track','genset',
        showMapToolBar: true,
        showVehicleIcons: true,
        showZonePolygons: true,
        showPlaceMarkers: true,
        tripLayers: {
            truckPath: true,
            plannedRoute: false,
            routeProgress: true,
            stops: true,
            routePlaces: true,
            routeAnnotations: false,
        },
        findLatLng: null,
        gensetViewportPadding: null,
        gensetViewportClip: null,
        gensetFocusAssetId: null,
        gensetTrackReportId: null,
    },

    reducers: {
        changeMapService: (state, { payload }) => {
            state.mapService = payload;
            return state;
        },
        setGoogleAvailable: (state, { payload }) => {
            state.googleAvailable = payload;
            return state;
        },
        zoomIn: (state) => {
            //console.log("Zoom in", state.zoom);
            state.zoom += 1;
            return state;
        },
        zoomOut: (state) => {
            state.zoom -= 1;
            return state;
        },
        setZoom: (state, { payload }) => {
            if (window.googlemap) {
                window.googlemap.setZoom(payload);
            }
            state.zoom = payload;
            return state;
        },
        setCenter: (state, { payload }) => {
            state.center = payload;
            return state;
        },
        resetMapDefault: (state) => {
            state.center = { lat: 23.5251, lng: 77.8081 };
            state.zoom = 6;
            return state;
        },
        panGoogleMap: (state, { payload }) => {
            state.center = payload;
            return state;
        },
        changeGoogleMapTypeId: (state, { payload }) => {
            state.googleMapTypeId = payload;
            return state;
        },
        resetMap: (state) => {
            state.center = { lat: 23.5251, lng: 77.8081 };
            state.zoom = 6;
            return state;
        },
        setNeedBounding: (state, { payload }) => {
            state.needBounding = payload;
            return state;
        },
        setMapControl: (state, { payload }) => {
            state.mapControl = payload;
            return state;
        },
        enableMapToolbar: (state) => {
            state.showMapToolBar = true;
            return state;
        },
        disableMapToolbar: (state) => {
            state.showMapToolBar = false;
            return state;
        },
        toggleVehicleIcons: (state, { payload }) => {
            if (payload) {
                state.showVehicleIcons = payload;
            } else {
                state.showVehicleIcons = !state.showVehicleIcons;
            }
            //console.log("toggleing vehicle icons", payload, "curr", state.showVehicleIcons)
            return state;
        },
        toggleZonePolygons: (state, { payload }) => {
            if (payload) {
                state.showZonePolygons = payload;
            } else {
                state.showZonePolygons = !state.showZonePolygons;
            }
            return state;
        },
        togglePlaceMarkers: (state, { payload }) => {
            if (payload) {
                state.showPlaceMarkers = payload;
            } else {
                state.showPlaceMarkers = !state.showPlaceMarkers;
            }
            return state;
        },
        toggleTripLayer: (state, { payload }) => {
            if (payload && Object.prototype.hasOwnProperty.call(state.tripLayers, payload)) {
                state.tripLayers[payload] = !state.tripLayers[payload];
            }
            return state;
        },
        resetTripLayers: (state) => {
            state.tripLayers = {
                truckPath: true,
                plannedRoute: false,
                routeProgress: true,
                stops: true,
                routePlaces: true,
                routeAnnotations: false,
            };
            return state;
        },
        setGensetViewportClip: (state, { payload }) => {
            state.gensetViewportClip = payload;
            return state;
        },
        clearGensetViewportClip: (state) => {
            state.gensetViewportClip = null;
            return state;
        },
        setFindLatLatLng: (state, { payload }) => {
            state.findLatLng = payload;
            state.mapControl = 'findlatlng';
            state.needBounding = true;
            return state;
        },
        resetFindLatLng: (state) => {
            state.findLatLng = null;
            if (state.mapControl === 'findlatlng') {
                state.mapControl = 'asset';
            }
            return state;
        },
        setGensetViewportPadding: (state, { payload }) => {
            state.gensetViewportPadding = payload;
            return state;
        },
        clearGensetViewportPadding: (state) => {
            state.gensetViewportPadding = null;
            return state;
        },
        setGensetFocusAssetId: (state, { payload }) => {
            state.gensetFocusAssetId = payload || null;
            return state;
        },
        setGensetTrackReportId: (state, { payload }) => {
            state.gensetTrackReportId = payload || null;
            return state;
        }


    },

});

export const zoomSelector = state => state.map.zoom;
export const centerSelector = state => state.map.center;
export const googleMapTypeIdSelector = state => state.map.googleMapTypeId;
export const needBoundingSelector = state => state.map.needBounding;
export const mapControlSelector = state => state.map.mapControl;
export const showMapToolBarSelector = state => state.map.showMapToolBar;
export const mapServiceSelector = state => state.map.mapService;
export const showVehicleIconsSelector = state => state.map.showVehicleIcons;
export const showZonePolygonsSelector = state => state.map.showZonePolygons;
export const showPlaceMarkersSelector = state => state.map.showPlaceMarkers;
export const tripLayersSelector = state => state.map.tripLayers;
export const googleAvailableSelector = state => state.map.googleAvailable;
export const findLatLngSelector = state => state.map.findLatLng;
export const gensetViewportPaddingSelector = state => state.map.gensetViewportPadding;
export const gensetViewportClipSelector = state => state.map.gensetViewportClip;
export const gensetFocusAssetIdSelector = state => state.map.gensetFocusAssetId;
export const gensetTrackReportIdSelector = state => state.map.gensetTrackReportId;


export const {
    changeMapService,
    setGoogleAvailable,
    zoomIn,
    zoomOut,
    setZoom,
    setCenter,
    panGoogleMap,
    changeGoogleMapTypeId,
    resetMap,
    setNeedBounding,
    setMapControl,
    resetMapDefault,
    enableMapToolbar,
    disableMapToolbar,
    toggleVehicleIcons,
    toggleZonePolygons,
    togglePlaceMarkers,
    toggleTripLayer,
    resetTripLayers,
    setGensetViewportClip,
    clearGensetViewportClip,
    setFindLatLatLng,
    resetFindLatLng,
    setGensetViewportPadding,
    clearGensetViewportPadding,
    setGensetFocusAssetId,
    setGensetTrackReportId
} = mapSlice.actions;
